var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import { Step } from '@shared/claim/steps';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
const claim = namespace('claim');
let AssistanceIndex = class AssistanceIndex extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/compensation/partnerArtisan.svg');
        this.isLoading = false;
    }
    backToDeclaration() {
        this.isLoading = true;
        this.updateAndSaveClaimStep(Step.ArtisanSecuringAppointmentIndex);
    }
};
__decorate([
    claim.Action('updateAndSaveClaimStep')
], AssistanceIndex.prototype, "updateAndSaveClaimStep", void 0);
AssistanceIndex = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
        },
    })
], AssistanceIndex);
export default AssistanceIndex;
